import React, { useState, FormEvent } from "react";
import { Stack } from "@wearewqa/wqa-design-system";
import { useNavigate } from "react-router-dom";
import { SignInFormInputs } from "./SignInFormInputs";
import { SignInFormActions } from "./SignInFormActions";
import { signInUsingFirebase } from "../../resources/auth/signInUsingFirebase";

type SignInFormData = {
  email: string;
  password: string;
};

export function SignInForm() {
  // TODO - Update 'showInfoBox' to accept text and states.
  const [hasError, setHasError] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [formData, setFormData] = useState<SignInFormData>({
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  function onInputChange(key: string, value: string) {
    setFormData((prevState) => ({ ...prevState, [key]: value }));
  }

  async function manageFormSubmit(
    event: FormEvent<HTMLFormElement>
  ): Promise<void> {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      // LOGIN
      await signInUsingFirebase(formData);
      navigate("/");
    } catch (error: unknown) {
      console.error(`Sign In Form - ${error as string}`);
      setHasError(true);
    }

    setIsSubmitting(false);
  }

  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <form onSubmit={(e) => manageFormSubmit(e)}>
      <Stack>
        <SignInFormInputs {...{ formData, onInputChange, hasError }} />
        <SignInFormActions {...{ isSubmitting }} />
      </Stack>
    </form>
  );
}
